import React, {useState, useEffect} from 'react';
import IntegrationMappings from './mappings';

const checkboxFilter = f => f.fieldType === 'CHECKBOX';

const shopifyCustomerFields = [
  {label: 'First name', key: 'firstName', type: 'field'},
  {label: 'Last name', key: 'lastName', type: 'field'},
  {label: 'Email', key: 'email', type: 'field'},
  {label: 'Consents to email marketing', key: 'acceptsEmailMarketing', type: 'field', sourceFieldFilter: checkboxFilter},
  {label: 'Phone number', key: 'phoneNumber', type: 'field'},
  {label: 'Consents to SMS marketing', key: 'acceptsSmsMarketing', type: 'field', sourceFieldFilter: checkboxFilter},
  {label: 'Address line 1', key: 'addressLine1', type: 'field'},
  {label: 'Address line 2', key: 'addressLine2', type: 'field'},
  {label: 'Company', key: 'company', type: 'field'},
  {label: 'Postal code', key: 'postalCode', type: 'field'},
  {label: 'City', key: 'city', type: 'field'},
  {label: 'Country', key: 'country', type: 'field'},
  {label: 'Country 2-letter code', key: 'country2LetterCode', type: 'field'},
  {label: 'Province', key: 'province', type: 'field'},
  {label: 'Province code', key: 'provinceCode', type: 'field'},
  {label: 'Note', key: 'note', type: 'field'},
  {label: 'Tags', key: 'tags', type: 'field-list'},
];

const ShopifyCustomerMappings = ({sourceFields, initialModel, onChange}) => {

  const [_sourceFields, setSourceFields] = useState(sourceFields);

  useEffect(() => setSourceFields(sourceFields), [sourceFields]);

  return <IntegrationMappings sourceFields={_sourceFields}
                              targetFields={shopifyCustomerFields}
                              initialModel={initialModel}
                              onChange={v => onChange(v)}/>
};

export default ShopifyCustomerMappings;
